"use strict";

import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _wrapNativeSuper from "@babel/runtime-corejs3/helpers/wrapNativeSuper";
import "core-js/modules/es.string.starts-with.js";
const GRAPH_ERROR_MEEAGE_PREFIX = 'GraphQLError';
export let GraphError = /*#__PURE__*/function (_Error) {
  function GraphError(message, graphqlErrors) {
    var _this;
    _this = _Error.call(this, message.startsWith(GRAPH_ERROR_MEEAGE_PREFIX) ? message : `${GRAPH_ERROR_MEEAGE_PREFIX}: ${message}`) || this;
    _this.graphqlErrors = graphqlErrors;
    return _this;
  }
  _inheritsLoose(GraphError, _Error);
  var _proto = GraphError.prototype;
  _proto.toValue = function toValue() {
    return this.toJSON();
  };
  _proto.toJSON = function toJSON() {
    return JSON.stringify(this.graphqlErrors);
  };
  return GraphError;
}(/*#__PURE__*/_wrapNativeSuper(Error));